import { GdprConsentResponse } from 'com.cogvio.pricemonitor.api';
import { apiClientMutator } from '~/infrastructure/config/mutator';

export type GdprConsentPayload = { termsConsent: boolean; marketingConsent: boolean };

export function postGdprConsent(data: GdprConsentPayload) {
	return apiClientMutator<GdprConsentResponse>({
		url: `/users/gdpr-consent/`,
		method: 'post',
		data: data,
	});
}

export function postGdprConsentFromPasswordReset(data: GdprConsentPayload, token: string) {
	return apiClientMutator<GdprConsentResponse>({
		url: `/users/gdpr-consent/from-password-reset/${token}`,
		method: 'post',
		data: data,
	});
}
